// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-wrap {
    background-color: #150924;
    color: white;
    padding: 91px 100px;
    font-family: "Inter", sans-serif;
}

.banner-content {
    text-align: left;
}

.banner-content .title {
    font-size: 52px;
    font-weight: 700;
    line-height: 68px;
    text-align: left;
    font-family: "Inter", sans-serif;
}

.banner-content .title span {
    background-color: #9256E8;
    color: white;
    padding: 0px 8px 4px;
}

.banner-content .description {
    font-size: 24px;
    font-weight: 400;
    line-height: 34px;
    text-align: left;
    max-width: 760px;
    font-family: "Inter", sans-serif;
}

.banner-content .sub-description {
    font-size: 24px;
    font-weight: 700;
    line-height: 34px;
    padding: 16px 0px;
}

.banner-buttons {
    align-items: center;
}

.banner-buttons button {
    padding: 0.75rem 2rem;
    border: none;
    cursor: pointer;
}

.banner-buttons .btn-dark {
    background-color: #00D49A;
    color: #242424;
    border: none;
    padding: 18px 48px;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
}

.banner-buttons .btn-dark img {
    height: 24px;
}

.banner-buttons .btn-light {
    background-color: transparent;
    color: #06EFC5;
    border: 1px solid transparent;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
}

.banner-buttons button:active {
    border: 1px solid transparent;
    box-shadow: none;
}

.banner-buttons button:focus {
    border: 1px solid transparent;
    box-shadow: none;
}

.banner-buttons .btn-light img {
    height: 24px;
}

.mob-banner-img {
    display: none;
}

.banner-right-img {
    display: block;
}

.banner-right-img img {
    width: 100%;
    /* height: 100%; */
}

.testimonial-card {
    position: relative;
    max-width: 500px;
    background-color: rgba(255, 255, 255, 0.13);
    padding: 11px 6px 15px 16px;
    border-radius: 30px 30px 30px 0px;
    margin-top: 65px;
}

.testimonial-card .testimonial-quote {
    position: absolute;
    right: 1%;
    top: -8%;
}

.testimonial-card .title {
    color: #FFF;
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: 38px;
    letter-spacing: -0.36px;
    margin-bottom: 0px;
    display: flex;
    font-family: "Inter", sans-serif;
}

.testimonial-card .title img {
    padding-right: 6px;
    height: 32px;
}

.testimonial-card .description {
    color: #FFF;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: -0.24px;
    padding: 9px 0px 5px;
    margin-bottom: 0px;
}

.testimonial-card .client-name {
    color: #FFF;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 38px;
    letter-spacing: -0.24px;
    position: relative;
    padding-left: 30px;
}

.testimonial-card .client-name::before {
    position: absolute;
    content: '';
    left: 1%;
    bottom: 50%;
    width: 21.5px;
    height: 1px;
    background-color: #FFF;
    opacity: 0.2;
}

@media (max-width: 1024px) {
    .banner-wrap{
        padding: 55px;
    }
}

@media (max-width: 768px) {
    .banner-wrap {
        padding: 40px 25px;
        text-align: center;
    }

    .banner-content .title {
        font-size: 25px;
        line-height: 39px;
        text-align: center;
        margin-bottom: 0px;
    }

    .banner-content .description {
        font-size: 18px;
        line-height: 28px;
        text-align: center;
        padding: 15px 0px;
        margin-bottom: 0px;
    }

    .banner-content .sub-description {
        font-size: 15px;
        line-height: 19px;
        text-align: center;
    }

    .banner-buttons {
        flex-direction: column;
        gap: 0.5rem;

    }

    .banner-buttons .btn-dark {
        width: 100%;
    }

    .banner-buttons .btn-light {
        width: 100%;
    }

    .banner-buttons a {
        width: 100%;
    }

    .mob-banner-img {
        display: block;
    }

    .banner-right-img {
        display: none;
    }

    .testimonial-card {
        margin-bottom: 30px;
    }

    .testimonial-card .title {
        font-size: 18px;
        line-height: 38px;
        letter-spacing: -0.36px;
    }

    .testimonial-card .description {
        font-size: 15px;
        line-height: 23px;
        letter-spacing: -0.3px;
        padding-bottom: 5px;
        text-align: left;
    }

    .testimonial-card .client-name {
        font-size: 12px;
        line-height: 38px;
        letter-spacing: -0.24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Banner/Banner.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,2BAA2B;IAC3B,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,WAAW;;IAEf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ","sourcesContent":[".banner-wrap {\n    background-color: #150924;\n    color: white;\n    padding: 91px 100px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.banner-content {\n    text-align: left;\n}\n\n.banner-content .title {\n    font-size: 52px;\n    font-weight: 700;\n    line-height: 68px;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n}\n\n.banner-content .title span {\n    background-color: #9256E8;\n    color: white;\n    padding: 0px 8px 4px;\n}\n\n.banner-content .description {\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 34px;\n    text-align: left;\n    max-width: 760px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.banner-content .sub-description {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 34px;\n    padding: 16px 0px;\n}\n\n.banner-buttons {\n    align-items: center;\n}\n\n.banner-buttons button {\n    padding: 0.75rem 2rem;\n    border: none;\n    cursor: pointer;\n}\n\n.banner-buttons .btn-dark {\n    background-color: #00D49A;\n    color: #242424;\n    border: none;\n    padding: 18px 48px;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n}\n\n.banner-buttons .btn-dark img {\n    height: 24px;\n}\n\n.banner-buttons .btn-light {\n    background-color: transparent;\n    color: #06EFC5;\n    border: 1px solid transparent;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n}\n\n.banner-buttons button:active {\n    border: 1px solid transparent;\n    box-shadow: none;\n}\n\n.banner-buttons button:focus {\n    border: 1px solid transparent;\n    box-shadow: none;\n}\n\n.banner-buttons .btn-light img {\n    height: 24px;\n}\n\n.mob-banner-img {\n    display: none;\n}\n\n.banner-right-img {\n    display: block;\n}\n\n.banner-right-img img {\n    width: 100%;\n    /* height: 100%; */\n}\n\n.testimonial-card {\n    position: relative;\n    max-width: 500px;\n    background-color: rgba(255, 255, 255, 0.13);\n    padding: 11px 6px 15px 16px;\n    border-radius: 30px 30px 30px 0px;\n    margin-top: 65px;\n}\n\n.testimonial-card .testimonial-quote {\n    position: absolute;\n    right: 1%;\n    top: -8%;\n}\n\n.testimonial-card .title {\n    color: #FFF;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 38px;\n    letter-spacing: -0.36px;\n    margin-bottom: 0px;\n    display: flex;\n    font-family: \"Inter\", sans-serif;\n}\n\n.testimonial-card .title img {\n    padding-right: 6px;\n    height: 32px;\n}\n\n.testimonial-card .description {\n    color: #FFF;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n    letter-spacing: -0.24px;\n    padding: 9px 0px 5px;\n    margin-bottom: 0px;\n}\n\n.testimonial-card .client-name {\n    color: #FFF;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 38px;\n    letter-spacing: -0.24px;\n    position: relative;\n    padding-left: 30px;\n}\n\n.testimonial-card .client-name::before {\n    position: absolute;\n    content: '';\n    left: 1%;\n    bottom: 50%;\n    width: 21.5px;\n    height: 1px;\n    background-color: #FFF;\n    opacity: 0.2;\n}\n\n@media (max-width: 1024px) {\n    .banner-wrap{\n        padding: 55px;\n    }\n}\n\n@media (max-width: 768px) {\n    .banner-wrap {\n        padding: 40px 25px;\n        text-align: center;\n    }\n\n    .banner-content .title {\n        font-size: 25px;\n        line-height: 39px;\n        text-align: center;\n        margin-bottom: 0px;\n    }\n\n    .banner-content .description {\n        font-size: 18px;\n        line-height: 28px;\n        text-align: center;\n        padding: 15px 0px;\n        margin-bottom: 0px;\n    }\n\n    .banner-content .sub-description {\n        font-size: 15px;\n        line-height: 19px;\n        text-align: center;\n    }\n\n    .banner-buttons {\n        flex-direction: column;\n        gap: 0.5rem;\n\n    }\n\n    .banner-buttons .btn-dark {\n        width: 100%;\n    }\n\n    .banner-buttons .btn-light {\n        width: 100%;\n    }\n\n    .banner-buttons a {\n        width: 100%;\n    }\n\n    .mob-banner-img {\n        display: block;\n    }\n\n    .banner-right-img {\n        display: none;\n    }\n\n    .testimonial-card {\n        margin-bottom: 30px;\n    }\n\n    .testimonial-card .title {\n        font-size: 18px;\n        line-height: 38px;\n        letter-spacing: -0.36px;\n    }\n\n    .testimonial-card .description {\n        font-size: 15px;\n        line-height: 23px;\n        letter-spacing: -0.3px;\n        padding-bottom: 5px;\n        text-align: left;\n    }\n\n    .testimonial-card .client-name {\n        font-size: 12px;\n        line-height: 38px;\n        letter-spacing: -0.24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
